export default "https://ssr-releases-cdn.paperlesspost.com/_next/static/video/tile_engagementparty-1a4e30f8506dfb2be1dfbf921e4ad60b.jpg";